export const AttachmentQcFieldName = 'attachmentQcFieldComponent';
